/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { CircularProgress } from '@material-ui/core'
import {
  FiClock,
  FiMail,
  FiSmartphone,
  FiUser,
} from 'react-icons/fi'
import * as Yup from 'yup'
import { MdSecurity } from 'react-icons/md'
import usePersistedState from '../../hooks/usePersistedState'
import calculaIdade from '../../utils/calculaIdade'
import Header from '../../components/Header'
import Button from '../../components/Button'
import {
  ConfigData,
  UserData,
  UserDetails,
  Participant,
  ErroProps,
} from '../../utils/interfaces'
import {
  Container,
  Content,
  BtnVoltar,
  Participants,
  InfoContent,
  Line,
  RadioButton,
  BtnOption,
  BtnModal,
} from './styles'
import ModalBox from '../../components/Modal'
import Input from '../../components/Input'
import getValidationErrors from '../../utils/getValidationErrors'
import { formatValue } from '../../utils/formatValues'

const Resume: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )

  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [aguarde, setAguarde] = useState(false)
  const [timer, setTimer] = useState(0)
  const [reSend, setReSend] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [txtModal] = useState('')

  const formRef = useRef<FormHandles>(null)

  let vlrDesconto = userDetails.contribuicaoSuplementar

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }
  const history = useHistory()

  const handleConfirmaAdesao = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({})
        const schema = Yup.object().shape({
          email: Yup.string()
            .email('Digite um e-mail válido')
            .required('E-mail obrigatório'),
          phone: Yup.string()
            .max(15, 'Telefone inválido')
            .min(14, 'Telefone inválido')
            .required('Celular obrigatório'),
        })

        await schema.validate(data, { abortEarly: false })

        await setUserData({
          ...userData,
          email: data.email,
          phone: data.phone,
        })

        history.push('/conclusion')
      } catch (err) {
        formRef.current?.setErrors(getValidationErrors(err))
      }
    },
    [setUserData, userData, history],
  )

  const dependents = participants.filter(
    participant => participant.details.grauParentesco !== undefined,
  )

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  const handleConfirmar = useCallback(event => {
    event.preventDefault()
    formRef.current?.submitForm()
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Resumo de Adesão</strong>
          <Form
            onSubmit={handleConfirmaAdesao}
            ref={formRef}
            initialData={{
              name: userData.name,
              cpf: userData.cpf,
              phone: userData.phone,
              email: userData.email,
            }}
          >
            <Participants>
              <h4>Dados pessoais</h4>
              <div className="titular">
                <Input
                  name="name"
                  placeholder="Nome"
                  sizeBox="small"
                  icon={FiUser}
                  disabled
                />
                <Input
                  placeholder="CPF"
                  name="cpf"
                  icon={MdSecurity}
                  type="tel"
                  mask="cpf"
                  sizeBox="small"
                  disabled
                />
                <Input
                  name="phone"
                  mask="phone"
                  placeholder="Celular com DDD"
                  icon={FiSmartphone}
                  sizeBox="small"
                />
                <Input
                  icon={FiMail}
                  name="email"
                  type="email"
                  placeholder="E-mail"
                  sizeBox="small"
                />
              </div>
            </Participants>

            <Line />

            <Participants>
              <h4>Contribuição</h4>
              <InfoContent>
                <div>
                  <p>Contribuição mensal:</p>
                  <strong>{userDetails.pctContribuicaoBasica}%</strong>
                </div>
                <div>
                  <p>Contribuição adicional:</p>
                  <strong>{formatValue(vlrDesconto)}</strong>
                </div>
                <button
                  className="edit"
                  type="button"
                  onClick={() => history.push('/contribution-values')}
                >
                  Simular novamente
                </button>
              </InfoContent>
            </Participants>

            <Line />

            <Participants>
              <h4>Informações adicionais</h4>
              <RadioButton>
                <label>Regime de Tributação</label>
                <div>
                  <BtnOption
                    type="button"
                    isActive={userDetails.tributacao === 'P'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        tributacao: 'P',
                      })
                    }}
                  >
                    Progressivo
                  </BtnOption>
                  <BtnOption
                    type="button"
                    isActive={userDetails.tributacao === 'R'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        tributacao: 'R',
                      })
                    }}
                  >
                    Regressivo
                  </BtnOption>
                </div>
              </RadioButton>

              <RadioButton>
                <label>Pessoa politicamente exposta (PPE)?</label>
                <div>
                  <BtnOption
                    type="button"
                    isActive={userDetails.ppe === 'S'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        ppe: 'S',
                      })
                    }}
                  >
                    Sim
                  </BtnOption>
                  <BtnOption
                    type="button"
                    isActive={userDetails.ppe === 'N'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        ppe: 'N',
                      })
                    }}
                  >
                    Não
                  </BtnOption>
                </div>
              </RadioButton>

              <RadioButton>
                <label>É residente no exterior para fins fiscais?</label>
                <div>
                  <BtnOption
                    type="button"
                    isActive={userDetails.usperson === 'S'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        usperson: 'S',
                      })
                    }}
                  >
                    Sim
                  </BtnOption>
                  <BtnOption
                    type="button"
                    isActive={userDetails.usperson === 'N'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        usperson: 'N',
                      })
                    }}
                  >
                    Não
                  </BtnOption>
                </div>
              </RadioButton>
            </Participants>

            <Participants>
              {participants.length > 0 ? (
                <>
                  <Line />
                  <h4>Beneficiários</h4>
                  <InfoContent>
                    {dependents.map(d => (
                      <div key={Math.random()} className="dependents">
                        <div className="infos">
                          <p>{d.data.name}</p>
                          <small>
                            {d.details.dcrGrauParentesco}
                            {', '}
                            {calculaIdade(d.data.birthdate)}{' '}
                            {calculaIdade(d.data.birthdate) > 1
                              ? 'anos'
                              : 'ano'}
                          </small>
                        </div>
                      </div>
                    ))}
                    {/* <button
                      className="edit"
                      type="button"
                      onClick={() => goback('b')}
                    >
                      Incluir novo beneficiário
                    </button> */}
                  </InfoContent>
                </>
              ) : (
                <></>
              )}
            </Participants>
          </Form>
        </Content>
        <Button
          type="button"
          color="blue"
          width="large"
          disabled={ !reSend || aguarde }
          onClick={handleConfirmar}
        >
          {!aguarde ? (
            !reSend ? (
              <>
                <FiClock size={36} />
                <span>
                  Tente novamente em {timer < 10 ? `0${timer}` : timer} segundos
                </span>
              </>
            ) : (
              <>
                <span>Confirmar informações</span>
              </>
            )
          ) : (
            <>
              <CircularProgress color="inherit" />
              <span>Aguarde</span>
            </>
          )}
        </Button>
        <BtnVoltar type="button" onClick={() => history.goBack()}>
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {txtModal}
          <BtnModal isActive onClick={() => handleCloseModal()}>
            Ok
          </BtnModal>
        </ModalBox>
      </Container>
    </>
  )
}

export default Resume
